import FieldContainer from 'refactored/features/soForm/steps/card/creditCard/Form/components/FieldContainer/styled';

export default FieldContainer;
